import { FormikProps, useFormik } from 'formik';
import { getAddSubscriptionPlanFormValidation } from './FormikData';
import { useTranslation } from 'react-i18next';
import { useGetRoles } from '../../../../services/redux/api/rolesApi';
import { FormikValues } from 'formik/dist/types';
import { usePostPutSubscriptionPlan } from '../../../../services/redux/api/subscriptionsApi';
import {
  SubscriptionPeriod,
  SubscriptionScope,
} from '../../../../shared/constants';
import { ISubscriptionPlan } from '../../../../types/interfaces/subscription-plan';

export function useAddSubscriptionPlanComponent(
  onClose: () => void,
  plan?: ISubscriptionPlan,
) {
  const { t } = useTranslation();
  const { data: roles } = useGetRoles();
  const [postPutSubscriptionPlan, { isLoading }] = usePostPutSubscriptionPlan();

  const formik: FormikProps<any> = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validationSchema: getAddSubscriptionPlanFormValidation(t),
    initialValues: {
      scope: plan?.scope || SubscriptionScope.starter,
      period: plan?.period || SubscriptionPeriod.monthly,
      stripePlanId: plan?.stripePlanId || '',
      orderNumber: plan?.orderNumber || 0,
    },
    onSubmit: onSubmit,
  });

  function onSubmit(values: FormikValues) {
    postPutSubscriptionPlan({
      id: plan?.id,
      body: {
        scope: values.scope,
        period: values.period,
        stripePlanId: values.stripePlanId,
        orderNumber: +values.orderNumber,
      },
    }).then((r) => {
      if (!('error' in r)) {
        onClose();
      }
    });
  }

  return { formik, roles, isLoading };
}
